export default {
  name: 'step-up-answer-edit',
  created () {
    this.search()

  },
  data () {
    return {
      isSearchEnd: false,
      isReSend: false,
      stepUpUser: null,
      answerContent: null,
      selectAnswers: [
        {id: 0, content: '回答前'},
        {id: 1, content: `努力が<br/>必要`},
        {id: 2, content: 'もう一歩'},
        {id: 3, content: 'できてる'},
        {id: 4, content: `大変よく<br/>できてる`}
      ]
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    isAllAnswer () {
      for (let i = 0; i < this.answerContent.length; i++) {
        if (this.answerContent[i].answer_content === 0) {
          return false
        }
      }
      return true
    },
  },
  methods: {
    async search () {
      let data = {
        id: this.$route.params.step_up_answer_id
      }

      let res = await this.$store.dispatch('STEPUP_ANSWER_DETAIL_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepUpUser = res.step_up_user
      this.answerContent = res.step_up_answer_details
      if (this.stepUpUser.is_all_answered) {
        this.isReSend = true
        this.selectAnswers.shift()
      } else {
        this.isReSend = false
      }
      this.isSearchEnd = true
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goStepUpAnswerList: function () {
      this.$router.push({ path: '/stepup/' + this.$route.params.step_up_answer_id + '/answered_list' })
    },
    async answerSend () {
      let data = {
        answerContent: this.answerContent
      }
      let stepUpAnswerId = this.$route.params.step_up_answer_id

      await Promise.all([
        this.$store.dispatch('STEPUP_ANSWER_UPDATE', {id: stepUpAnswerId, data: data}),
        this.$store.dispatch('STEPUP_ALL_ANSWER_UPDATE', {id: stepUpAnswerId})
      ])
      .catch(err => {
        console.log(err)
        return
      })
      // モーダル表示
      this.stepupSendModal('send')
    },
    async tempSave () {
      let data = {
        answerContent: this.answerContent
      }
      await this.$store.dispatch('STEPUP_ANSWER_UPDATE', {id: this.$route.params.step_up_answer_id, data: data})
      .catch(err => {
        console.log(err)
        return
      })
      // モーダル表示
      this.stepupSendModal('temp')
    },
    selectedStyle: function (index, radioVal) {
      if (this.isReSend) {
        if (this.answerContent[index].answer_content == (radioVal + 1)) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      } else {
        if (this.answerContent[index].answer_content == radioVal) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    isAnswered: function (id) {
      return id === 0? '' : 'answered'
    },
    stepupSendModal: function (mode) {
      let modal = ''
      if (mode === 'send') {
        modal = 'stepupSendModalButton'
      } else {
        modal = 'stepupTempSaveModalButton'
      }
      const button = document.getElementById(modal)
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/step-up-answer-edit.js